export default "__VITE_ASSET__82881faa__"